import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.DeleteQuestionsForCompetencyRequest;
const ACTIONS    = [
  ActionType.DeleteQuestionsForCompetencyRequest,
  ActionType.DeleteQuestionsForCompetencyResponse,
  ActionType.DeleteQuestionsForCompetencyError,
];


type Payload = boolean;

type Meta = {
  competencyId: number;
  projectId: number;
};


/**
 * Dispatch this action to delete the dev plan items made by the user
 */
export const deleteQuestionsForCompetencyAction = (
  projectId: number,
  participantId: number,
  competencyId: number,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.DeleteQuestionsForCompetency,
  headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
  body:     state => JSON.stringify({
    projectId,
    participantId,
    competencyId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { competencyId, projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION, competencyId),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const competencyId = action.meta.competencyId;
  if (isLoading) {
    return addLoading(state, KEY_ACTION, competencyId);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, competencyId);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, competencyId);

  return R.assocPath(
    ['selectedQuestions', `${action.meta.projectId}`],
    successState.selectedQuestions?.
      [`${action.meta.projectId}`].
      filter(item => item.competencyId !== competencyId || item.required) ?? [],
    R.dissocPath(['selectedQuestions', `${action.meta.projectId}`, `${action.meta.competencyId}`], successState),
  );
};


export const deleteQuestionsForCompetencyReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
